import React, { useEffect, useState } from 'react';

const InstallPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showPrompt, setShowPrompt] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowPrompt(true);
    };
    window.addEventListener('beforeinstallprompt', handler);

    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then((choiceResult) => {
        console.log('User choice:', choiceResult.outcome);
        setDeferredPrompt(null);
        setShowPrompt(false);
      });
    }
  };

  const handleClose = () => setShowPrompt(false);

  if (!showPrompt) return null;

  return (
    <div style={popupStyle}>
      <p>Install our app for a better experience!</p>
      <button
  onClick={handleInstall}
  style={{
    marginBottom: '10px',
    backgroundColor: '#007bff',
    color: '#fff',
    border: 'none',
    padding: '10px 20px',
    borderRadius: '5px',
    cursor: 'pointer',
  }}
>
  Install
</button>
<button
  onClick={handleClose}
  style={{
    backgroundColor: '#ccc',
    border: 'none',
    padding: '10px 20px',
    borderRadius: '5px',
    cursor: 'pointer',
  }}
>
  No Thanks
</button>


    </div>
  );
};

const popupStyle = {
    position: 'fixed',
    top: '60px', // Adjust this depending on your header height
    left: '50%',
    transform: 'translateX(-50%)',
    background: '#fff',
    padding: '12px 20px',
    border: '1px solid #ccc',
    borderRadius: '8px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
    zIndex: 9999,
    display: 'flex',
    gap: '10px',
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
    maxWidth: '90%',
    textAlign: 'center',
  };
  
  

export default InstallPrompt;
